import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, of, Subscriber, Subscription } from 'rxjs';
import { PackWizard } from 'src/app/shared/state/pack-wizard/pack-wizard.model';
import { PackWizardQuery } from 'src/app/shared/state/pack-wizard/pack-wizard.query';

@Component({
  standalone: false,
  selector: 'app-pack-item',
  templateUrl: './pack-item.component.html',
  styleUrls: ['./pack-item.component.scss']
})
export class PackItemComponent {
  @Input() pack: PackWizard;
  @Input() packIsChecked$: Observable<boolean>;
  @Output() packToggleEvent = new EventEmitter<any>();

  public checked: boolean;

  private subscription$: Subscription;

  constructor(
    private packWizardQuery: PackWizardQuery
    ) {}

  ngOnInit() {
    this.subscription$ = this.packWizardQuery.selectEntity(
      e => e.id === this.pack.id
    ).subscribe(({isChecked}) => {
      this.checked = isChecked;
    });
    
  }

  /**
   * Passes along the checked value from the event instead of just the pack:
   * `flw-service-selector`'s inner checkbox re-emits `flwChange` whenever its
   * `checked` prop changes for *any* reason, not only on a direct click —
   * including when this row's own checked state is pushed down externally
   * (e.g. a sibling pack toggling the services this pack is also linked to).
   * A handler that blindly flips on every event turns that echo into an
   * infinite on/off loop; setting to the event's own value is idempotent.
   */
  onPackToggle(event: CustomEvent<{ checked: boolean }>) {
    this.packToggleEvent.emit({ pack: this.pack, checked: event.detail.checked });
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
